if (!customElements.get('show-more-button')) {
  customElements.define(
    'show-more-button',
    class ShowMoreButton extends HTMLElement {
      constructor() {
        super();
        const button = this.querySelector('button');
        button.addEventListener('click', (event) => {
          const wasExpanded = this.isExpanded();
          this.expandShowMore(event);

          if (wasExpanded) {
            this.scrollToFilterTop(event);
            return;
          }

          const nextElementToFocus = event.target.closest('.parent-display').querySelector('.show-more-item');
          if (nextElementToFocus && !nextElementToFocus.classList.contains('hidden') && nextElementToFocus.querySelector('input')) {
            nextElementToFocus.querySelector('input').focus();
          }
        });
      }

      isExpanded() {
        const showLessLabel = this.querySelector('.label-show-less');
        return Boolean(showLessLabel) && !showLessLabel.classList.contains('hidden');
      }

      scrollToFilterTop(event) {
        const filterDetails = (event.target && event.target.closest('.js-filter')) || this.closest('.js-filter');
        if (!filterDetails) return;

        const scrollTarget = filterDetails.querySelector('summary') || filterDetails;

        requestAnimationFrame(() => {
          scrollTarget.scrollIntoView({ behavior: 'smooth', block: 'start' });
        });
      }

      expandShowMore(event) {
        const parentDisplay = event.target.closest('[id^="Show-More-"]').closest('.parent-display');
        const parentWrap = parentDisplay.querySelector('.parent-wrap');
        this.querySelectorAll('.label-text').forEach((element) => element.classList.toggle('hidden'));
        parentDisplay.querySelectorAll('.show-more-item').forEach((item) => item.classList.toggle('hidden'));
        if (!this.querySelector('.label-show-less')) {
          this.classList.add('hidden');
        }
      }
    }
  );
}
